import { isNativeFieldApp, isPhoneDevice } from './installPrompt';

export const NATIVE_WEB_KEY = 'lgl-m-native-allow-web';

export const isFieldAppPath = (pathname = '') =>
  pathname === '/m' || String(pathname).startsWith('/m/');

/** Admin Panel hosted inside LGL Portal (same tabs as /admin). */
export const isFieldAdminPath = (pathname = '') =>
  pathname === '/m/admin' || String(pathname).startsWith('/m/admin/');

export const fieldAdminPath = () => '/m/admin';

export const allowNativeWebsite = (win = typeof window === 'undefined' ? undefined : window) => {
  try { win?.sessionStorage?.setItem(NATIVE_WEB_KEY, '1'); } catch { /* ignore */ }
};

export const nativeWebsiteAllowed = (win = typeof window === 'undefined' ? undefined : window) => {
  try { return win?.sessionStorage?.getItem(NATIVE_WEB_KEY) === '1'; } catch { return false; }
};

export const clearNativeWebsite = (win = typeof window === 'undefined' ? undefined : window) => {
  try { win?.sessionStorage?.removeItem(NATIVE_WEB_KEY); } catch { /* ignore */ }
};

export const shouldBounceNativeToField = (
  pathname,
  win = typeof window === 'undefined' ? undefined : window
) => isNativeFieldApp(win) && !nativeWebsiteAllowed(win) && !isFieldAppPath(pathname);

/** ?desktop=1 keeps a phone on the regular portal (same session flag as Open full website). */
export const desktopForcedByUrl = (win = typeof window === 'undefined' ? undefined : window) => {
  if (!win?.location) return false;
  try {
    const q = new URLSearchParams(win.location.search || '');
    if (q.get('desktop') === '1' || q.get('desktop') === 'true') return true;
  } catch { /* ignore */ }
  return String(win.location.hash || '').toLowerCase().includes('desktop=1');
};

const isDownloadAppPath = (pathname = '') => {
  const path = String(pathname).split('?')[0];
  return path === '/download-app' || path.startsWith('/download-app/');
};

/**
 * Browser phones open `/m`. Tablets and desktops stay on the regular portal.
 * Download App and Open full website (?desktop=1 / session flag) are the exits.
 */
export const shouldRedirectPhoneToField = (
  pathname,
  win = typeof window === 'undefined' ? undefined : window
) => {
  if (isFieldAppPath(pathname) || isDownloadAppPath(pathname)) return false;
  if (desktopForcedByUrl(win)) {
    allowNativeWebsite(win);
    return false;
  }
  if (nativeWebsiteAllowed(win)) return false;
  return isPhoneDevice(win);
};

export const shouldShowNativeWebsiteBar = (
  pathname,
  win = typeof window === 'undefined' ? undefined : window
) => (
  nativeWebsiteAllowed(win)
  && !isFieldAppPath(pathname)
  && (isNativeFieldApp(win) || isPhoneDevice(win))
);

export const openInsideNativeApp = (url, win = typeof window === 'undefined' ? undefined : window) => {
  if (!win) return;
  allowNativeWebsite(win);
  win.location.href = url;
};
